// Sdílený helper na ikony ze SVG spritu (injectSprite.js ho vkládá inline do <body>,
// takže `href="#bs-i-…"` míří do stejného dokumentu a currentColor funguje).
//
// Používej všude, kde JS staví vlastní markup — ať nikde nevzniká druhá varianta
// zápisu ikony.

const NS = 'http://www.w3.org/2000/svg';

// <svg class="bs-icon …"><use href="#bs-i-name"></use></svg>
export function icon(name, className) {
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('class', className ? 'bs-icon ' + className : 'bs-icon');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  const use = document.createElementNS(NS, 'use');
  use.setAttribute('href', '#bs-i-' + name);
  svg.appendChild(use);
  return svg;
}

// Verze pro innerHTML skládané řetězcem.
export function iconHtml(name, className) {
  return (
    '<svg class="' + (className ? 'bs-icon ' + className : 'bs-icon') +
    '" aria-hidden="true" focusable="false"><use href="#bs-i-' + name + '"></use></svg>'
  );
}

// <a> / <button> s ikonou + textem (text volitelný).
export function el(tag, className, attrs) {
  const node = document.createElement(tag);
  if (className) node.className = className;
  if (attrs) {
    for (const k in attrs) {
      if (attrs[k] != null) node.setAttribute(k, attrs[k]);
    }
  }
  return node;
}
